import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { store } from './store'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import 'bootstrap/dist/css/bootstrap.min.css'
import './index.css'
import './tailwind.build.css'
import App from './App'
import * as serviceWorker from './serviceWorker'
import { ThemeProvider } from "@mui/material/styles"
import { theme } from "./components/mui/theme"
import { enableMapSet } from "immer"
import { PostHogProvider } from 'posthog-js/react'
import posthog from 'posthog-js';

enableMapSet()

const queryClient = new QueryClient()

const shouldInitializePosthog = window.location.host === 'app.wistor.nl'

if (shouldInitializePosthog) {
  posthog.init("phc_lcSbPaVY02anFTqIXtz1Q4AF17ScWZLkVoc6i7s5kxP", {
    api_host: "https://posthog.bim-connected.com",
    defaults: '2025-05-24',
  });
}

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <Provider store={store}>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <PostHogProvider client={posthog}>
          <App />
        </PostHogProvider>
      </ThemeProvider>
    </QueryClientProvider>
  </Provider>
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister()
//serviceWorker.register();
